import { generateHooks } from "../generators/generator.hooks";
var crudHooks = generateHooks({
    entity: "ApplicationFilter",
    reducerKey: "applicationFilters",
    basePathEntity: "application-filters",
});
export var useApplicationFilters = crudHooks;
export var useGetApplicationFilters = function () {
    var _a = crudHooks.useGetAll({
        query: {},
        shouldRefetch: true,
    }), items = _a.items, isFetching = _a.isFetching, fetchError = _a.fetchError, refetch = _a.refetch;
    return {
        applicationFilters: items,
        isFetching: isFetching,
        fetchError: fetchError,
        refetch: refetch,
    };
};
